import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/switchMap';
import type { ActionsObservable } from 'redux-observable';
import { toSimplifiedViewLog } from '@atlassian/jira-servicedesk-automation-common/src/navigation';
import {
	projectKeySelector,
	baseUrlSelector,
} from '@atlassian/jira-servicedesk-automation-common/src/state/selectors/app-props';
import { VIEW_LOG, type ViewLogAction } from '../../../state/actions/rule/view-log';
import type { State } from '../../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<ViewLogAction>, store: MiddlewareAPI<State>) =>
	action$.ofType(VIEW_LOG).switchMap((action) => {
		const state = store.getState();
		const projectKey = projectKeySelector(state);
		const { ruleSetId } = action.payload;
		return toSimplifiedViewLog(baseUrlSelector(state), projectKey, ruleSetId);
	});
